module.exports = __webpack_public_path__ + "media/images/Carta-recomendacion-2c4780dc335fd3de0dbf8f0c60c98437.png";